require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-the-role-of-emotion-in-automotive-purchasing-and-what-this-means-for-car-retailers.json") })
        }
      }, "path---authors-the-role-of-emotion-in-automotive-purchasing-and-what-this-means-for-car-retailers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-the-role-of-emotion-in-automotive-purchasing-and-what-this-means-for-car-retailers!./.cache/json/authors-the-role-of-emotion-in-automotive-purchasing-and-what-this-means-for-car-retailers.json
// module id = 1350
// module chunks = 231608221292675